import React, { useState } from 'react';
import { CameraIcon, UploadIcon, XIcon } from 'lucide-react';
export function PhotoUploader({
  onImageCapture,
  onCancel
}) {
  const [isUploading, setIsUploading] = useState(false);
  const handleFileChange = e => {
    const file = e.target.files[0];
    if (!file) return;
    // Check if file is an image
    if (!file.type.startsWith('image/')) {
      alert('Please upload an image file');
      return;
    }
    // Check file size (limit to 5MB)
    if (file.size > 5 * 1024 * 1024) {
      alert('Image size should be less than 5MB');
      return;
    }
    setIsUploading(true);
    const reader = new FileReader();
    reader.onload = event => {
      // Simulate OCR processing with a timeout
      setTimeout(() => {
        // Generate some sample OCR data
        const ocrData = {
          name: 'Summer Music Festival 2023',
          date: new Date().toISOString().split('T')[0],
          time: '18:00',
          location: 'Central Park, New York',
          category: 'music',
          notes: 'Join us for a day of amazing music with local artists!',
          image: event.target.result,
          isFree: false,
          feeAmount: '$20'
        };
        onImageCapture(ocrData);
        setIsUploading(false);
      }, 1500); // Simulate 1.5 second processing time
    };
    reader.readAsDataURL(file);
  };
  return <div className="fixed inset-0 bg-black bg-opacity-90 z-50 flex flex-col items-center justify-center animate-fadeIn" data-id="element-366">
      <div className="w-full max-w-lg p-4" data-id="element-367">
        <div className="flex justify-between items-center mb-8" data-id="element-368">
          <button onClick={onCancel} className="text-white p-2" data-id="element-369">
            <XIcon className="w-6 h-6" data-id="element-370" />
          </button>
          <h2 className="text-lg font-medium text-white" data-id="element-371">Capture Event</h2>
          <div className="w-10" data-id="element-372"></div> {/* Empty div for spacing */}
        </div>
        {isUploading ? <div className="flex flex-col items-center justify-center h-80 bg-gray-800 rounded-xl" data-id="element-373">
            <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-white" data-id="element-374"></div>
            <p className="text-white mt-4" data-id="element-375">Processing image...</p>
          </div> : <div className="bg-gray-800 rounded-xl p-6 flex flex-col items-center" data-id="element-376">
            <div className="border-2 border-dashed border-gray-500 rounded-lg p-8 w-full h-64 flex flex-col items-center justify-center mb-4" data-id="element-377">
              <CameraIcon className="w-16 h-16 text-gray-400 mb-4" data-id="element-378" />
              <p className="text-white text-center mb-2" data-id="element-379">
                Take a photo of the event flyer
              </p>
              <p className="text-gray-400 text-sm text-center" data-id="element-380">
                We'll extract the event details automatically
              </p>
            </div>
            <div className="flex w-full space-x-4" data-id="element-381">
              <label className="flex-1" data-id="element-382">
                <input type="file" accept="image/*" capture="environment" onChange={handleFileChange} className="hidden" data-id="element-383" />
                <div className="bg-blue-600 py-3 rounded-lg text-white font-medium flex items-center justify-center cursor-pointer" data-id="element-384">
                  <CameraIcon className="w-5 h-5 mr-2" data-id="element-385" />
                  Take Photo
                </div>
              </label>
              <label className="flex-1" data-id="element-386">
                <input type="file" accept="image/*" onChange={handleFileChange} className="hidden" data-id="element-387" />
                <div className="bg-gray-700 py-3 rounded-lg text-white font-medium flex items-center justify-center cursor-pointer" data-id="element-388">
                  <UploadIcon className="w-5 h-5 mr-2" data-id="element-389" />
                  Upload Image
                </div>
              </label>
            </div>
          </div>}
      </div>
    </div>;
}